import React from 'react';

import { Icon, IconProps } from '@chakra-ui/icons';

export const RepublicBlackRLogoIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="28px"
    height="32px"
    viewBox="0 0 28 32"
    {...props}
  >
    <path
      d="M27.6852 30.3609L19.9464 18.231C21.3042 17.6181 22.5155 16.6882 23.4599 15.5175C24.8211 13.8309 25.5701 11.7055 25.5701 9.53472C25.5701 4.27694 21.2932 0 16.0354 0H1.06614C0.478043 0 0 0.478043 0 1.06614V30.9339C0 31.522 0.478043 32 1.06614 32H26.7869C27.1769 32 27.5353 31.7875 27.7224 31.4456C27.9095 31.1038 27.895 30.6876 27.6859 30.3602L27.6852 30.3609ZM16.0354 2.0635C20.1548 2.0635 23.5067 5.4153 23.5067 9.53472C23.5067 11.2612 22.9351 12.8817 21.8538 14.2223C21.049 15.2197 19.9973 15.9942 18.8218 16.4688L9.63102 2.0635H16.0354ZM11.581 16.7913L14.0765 12.868L16.5795 16.7913H11.581ZM13.0268 18.8548V29.9365H3.22112L10.2693 18.8548H13.0275H13.0268ZM2.0635 2.0635H7.18372L12.8521 10.9482L9.13578 16.7913H2.0635V2.0635ZM7.8234 18.8548L2.0635 27.9122V18.8555H7.8234V18.8548ZM15.0903 29.9365V18.8548H17.8967L24.9669 29.9365H15.0903Z"
      fill="#0049FF"
    />
  </Icon>
);
